<div class="susc-container" [ngClass]="{'dark-theme': isDark}">

  <!-- Header -->
  <div class="susc-header">
    <h2 class="susc-title">
      <mat-icon>manage_accounts</mat-icon>
      Automatización Carteras
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="susc-content">

    <!-- Loading -->
    <div *ngIf="isLoadingSuscripciones" class="loading-state">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Cargando suscripciones...</span>
    </div>

    <!-- Empty state -->
    <div *ngIf="!isLoadingSuscripciones && (!listaSuscripciones || listaSuscripciones.length === 0)"
         class="empty-state">
      <mat-icon class="empty-icon">subscriptions</mat-icon>
      <p>No se tienen suscripciones registradas.</p>
    </div>

    <!-- Table -->
    <div *ngIf="!isLoadingSuscripciones && listaSuscripciones && listaSuscripciones.length > 0"
         class="params-table-wrapper">
      <table class="susc-table">
        <thead>
          <tr>
            <th class="sortable-header" (click)="ordenarPor('fecharegistro')">
              Fecha registro
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'fecharegistro'">{{ getSortIcon('fecharegistro') }}</mat-icon>
            </th>
            <th class="col-left sortable-header" (click)="ordenarPor('nombre')">
              Cartera
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'nombre'">{{ getSortIcon('nombre') }}</mat-icon>
            </th>
            <th>Subcarteras</th>
            <th class="sortable-header" (click)="ordenarPor('horaentrada')">
              Hora entrada
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'horaentrada'">{{ getSortIcon('horaentrada') }}</mat-icon>
            </th>
            <th class="sortable-header" (click)="ordenarPor('horasalida')">
              Hora salida
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'horasalida'">{{ getSortIcon('horasalida') }}</mat-icon>
            </th>
            
            <th class="sortable-header" (click)="ordenarPor('suscrito')">
              Suscribir
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'suscrito'">{{ getSortIcon('suscrito') }}</mat-icon>
            </th>

            <th class="sortable-header" (click)="ordenarPor('fechasuscripcion')">
              Fecha suscripción
              <mat-icon class="sort-icon" [class.active]="sortColumn === 'fechasuscripcion'">{{ getSortIcon('fechasuscripcion') }}</mat-icon>
            </th>
            <th class="sortable-header" (click)="ordenarPor('broker')">
              Vincular Broker
                            <mat-icon class="sort-icon" [class.active]="sortColumn === 'broker'">{{ getSortIcon('broker') }}</mat-icon>
            </th>
            <!--th>Gestor</th-->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let suscripcion of listaSuscripciones">
                        <td class="date-cell">{{ suscripcion.fecharegistro | date: 'dd/MM/yyyy HH:mm' }}</td>

            <td class="col-left cartera-cell">
              <span class="cartera-name" [title]="suscripcion.nombre">{{ suscripcion.nombre }}</span>
              <span
                *ngIf="!($any(suscripcion).idsubcarteras && $any(suscripcion).subcarteras) && suscripcion.bajista !== undefined"
                class="trend-icon"
                [class.trend-down]="suscripcion.bajista === 'true'"
                [class.trend-up]="suscripcion.bajista !== 'true'"
                [matTooltip]="suscripcion.bajista === 'true' ? 'Bajista' : 'Alcista'">{{ suscripcion.bajista === 'true' ? '↓' : '↑' }}</span>
              <span *ngIf="suscripcion.periodo" class="meta-api-tag">{{ anyTrueCsv(suscripcion.metaApi) ? 'MetaApi - ' : '' }}{{ formatPeriodoCsv(suscripcion.periodo) }}</span>
            </td>
            <td>
              <ng-container *ngIf="$any(suscripcion).idsubcarteras && $any(suscripcion).subcarteras">
                <ng-container *ngFor="let idModelo of $any(suscripcion).idsubcarteras.split(','); let i = index; let last = last">
                  <span
                    *ngIf="suscripcion.bajista"
                    class="trend-icon"
                    [class.trend-down]="suscripcion.bajista.split(',')[i]?.trim() === 'true'"
                    [class.trend-up]="suscripcion.bajista.split(',')[i]?.trim() !== 'true'"
                    [matTooltip]="suscripcion.bajista.split(',')[i]?.trim() === 'true' ? 'Bajista' : 'Alcista'">{{ suscripcion.bajista.split(',')[i]?.trim() === 'true' ? '↓' : '↑' }}</span>
                  <a [href]="'/models?id=' + idModelo.trim() + '&idcarteraoptima=' + getIdCarteraOptima(suscripcion, i)" target="_blank" class="sub-link">
                    {{ $any(suscripcion).subcarteras.split(',')[i].trim() }}
                  </a>
                  <ng-container *ngIf="!last">, </ng-container>
                </ng-container>
              </ng-container>
            </td>
            
            <td>
              <input type="time" class="time-input"
                     [(ngModel)]="suscripcion.horaentrada"
                     (focusout)="cambiarHoraEntradaSalida(suscripcion)" />
            </td>
            <td>
              <input type="time" class="time-input"
                     [(ngModel)]="suscripcion.horasalida"
                     (focusout)="cambiarHoraEntradaSalida(suscripcion)" />
            </td>
            <td class="center-cell">
              <mat-checkbox [(ngModel)]="suscripcion.suscrito"
                            (change)="suscribirModelo($event.checked, suscripcion)"
                            [disabled]="!!suscripcion.broker || !!suscripcion.gestor">
              </mat-checkbox>
            </td>
            <td class="date-cell">{{ $any(suscripcion).fechasuscripcion | date: 'dd/MM/yyyy HH:mm' }}</td>

            <td class="center-cell">
              <div class="broker-cell">
                <mat-checkbox [(ngModel)]="suscripcion.broker"
                              [disabled]="!suscripcion.suscrito"
                              (change)="enviarBroker($event.checked, suscripcion)">
                </mat-checkbox>
                <span *ngIf="suscripcion.broker" class="meta-api-tag">{{ suscripcion.nombrecarterabroker }}</span>
              </div>
            </td>
            <!--td class="center-cell">
              <mat-checkbox [(ngModel)]="suscripcion.gestor"
                            [disabled]="!suscripcion.suscrito"
                            (change)="enviarGestor($event.checked, suscripcion)">
              </mat-checkbox>
            </td-->
            <td class="center-cell">
              <button mat-icon-button class="delete-btn" (click)="eliminar(suscripcion)" title="Eliminar suscripción">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
